import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=c4ff3844&scoped=true"
import script from "@/controllers/estimates/detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/estimates/detail.js?vue&type=script&lang=js&external"
import style0 from "./Detail.styles.scss?vue&type=style&index=0&id=c4ff3844&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ff3844",
  null
  
)

export default component.exports